export { default } from './CDCProtegido25';
